import util from '@utils/util';
export default {
  name: 'CardFollow',
  props: {
    countInfo: Object,
    userInfo: Object
  },
  filters: {
    format: function format(val) {
      return util.nFormatter(val, 1);
    }
  }
};